import * as yup from "yup";
import { Formik } from "formik";
import { useEffect, useRef, useState } from "react";
import { Icon } from "@iconify/react";
import { Button } from "../../../components/ui/button";
import Common from "../../../helper/common";
import {
  FormikInput,
  PhoneInputField,
  FormikTextArea,
} from "../../../components/formik-components";
import { respEnum } from "../../../constants/appConstant";
import toast from "react-hot-toast";
import {
  Dialog,
  DialogClose,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from "../../../components/ui/dialog";
import { useNavigate } from "react-router-dom";

const FormikInitialValues = {
  phone: "",
  phoneCode: "+92",
  phoneNum: "",
  cnic: "",
  address: "",
};

const formikValidation = yup.object({
  firstName: yup.string().required("First Name is required"),
  lastName: yup.string().required("Last Name is required"),
  //phone: yup
  //    .string()
  //    .nullable()
  //   /* .matches(/^\d{3}-\d{7}$/, "Phone must be in the format 301-2345678")*/
  //    .required("Phone Number is required"),

  phone: yup
    .string()
    .required("Phone Number is required")
    .min(5)
    .matches(/^\+?[1-9]\d{1,14}$/, "Phone number must be valid"),

  email: yup.string().nullable().email("Invalid email format").notRequired(),
  cnic: yup
    .string()
    .nullable()
    .matches(
      /^\d{5}-\d{7}-\d{1}$/,
      "CNIC must be in the format 42101-1234567-8"
    )
    .notRequired(),
  address: yup
    .string()
    .nullable()
    .min(10, "Address must be at least 10 characters")
    .max(1000, "Address cannot exceed 1000 characters")
    .notRequired(),
});

const AddCustomer = ({ id, onClose, open, setOpen, bookingModal }) => {
  const formikRef = useRef();
  const dialogRef = useRef();
  const navigate = useNavigate();
  const [isFormikInitialized, setIsFormikInitialized] = useState(false);

  const [isPhonePresent, setIsPhonePresent] = useState(false);
  const [mode, setMode] = useState(id ? true : false);
  const [existingCustomerDetails, setExistingCustomerDetails] = useState(null);

  useEffect(() => {
    setMode(id ? true : false);
    setIsFormikInitialized(open);
    // Clear existing customer details when modal opens
    if (open) {
      setExistingCustomerDetails(null);
    }
  }, [open, id]);

  const onSubmitAddCustomer = async (d, action) => {
    debugger;

    let data = {
      ...d,
      id,
      phone: d.phoneNum ? d.phoneNum : d.phone,
      email: d.email,
      cnic: d.cnic,
      address: d.address,
    };
    if (!data.phone) {
      action.setSubmitting(false);
      if (formikRef.current) {
        formikRef.current.setSubmitting(false);
      }
      toast.error("Phone is Required");
      return;
    }
    
    try {
      let response = await Common.ApiService.getInstance().request(
        "AddUpdateClubPlayer",
        data,
        "POST",
        true,
        true,
        true
      );

      // Always reset submitting state IMMEDIATELY after API call
      action.setSubmitting(false);
      if (formikRef.current) {
        formikRef.current.setSubmitting(false);
      }

      if (response.status == respEnum.Success) {
        onClose(response.data, d.phone);
        setOpen(false);
        if (!onClose) {
          navigate("/app/clubcustomers", { replace: true });
        }
        // setTimeout(() => {
        //     SweetAlert.alert(response.message);
        // }, 500)
      } else {
        debugger;
        // Handle validation errors and show existing customer details
        if (response.data && typeof response.data === "object") {
          console.log("Setting existing customer details:", response.data);
          setExistingCustomerDetails(response.data);
          // Don't show toast here - API service already shows it when showMessage is true
          // The yellow alert box will show the details
        } else {
          // Don't show toast here - API service already shows it when showMessage is true
          setExistingCustomerDetails(null);
        }
      }
    } catch (error) {
      // Ensure submitting state is reset on error
      action.setSubmitting(false);
      if (formikRef.current) {
        formikRef.current.setSubmitting(false);
      }
      toast.error(error.message || "An error occurred");
    }
  };

  const getCustomerInfo = async () => {
    if (!mode || !id) {
      return;
    }

    let response = await Common.ApiService.getInstance().request(
      `GetClubPlayerDetails?playerId=${id}`
    );

    if (response.status === respEnum.Success) {
      debugger;

      if (id && response?.data?.length) {
        const customer = response.data[0];

        // Construct full phone number with country code for PhoneInputField
        // PhoneInputField expects phone to be in format: +923020244112
        const fullPhone =
          customer.phoneCode && customer.phone
            ? `${customer.phoneCode}${customer.phone}`
            : customer.phone || customer.phoneNum || "";

        const transformedData = {
          ...customer,
          phone: fullPhone, // Full phone with country code for PhoneInputField
          phoneCode: customer.phoneCode || "+92", // Country code
          phoneNum: customer.phone || customer.phoneNum || "", // Phone number without country code
        };

        if (formikRef.current) {
          formikRef.current.setValues({
            ...formikRef.current.values, // Preserve existing values
            ...transformedData, // Update with transformed data
          });
        }

        const isPhoneNumberPresent =
          (customer.phone || customer.phoneNum)?.trim()?.length > 0;

        console.log(isPhoneNumberPresent);
        setIsPhonePresent(isPhoneNumberPresent);
      } else {
        setIsPhonePresent(!mode);
      }
    }
  };
  useEffect(() => {
    if (mode) {
      getCustomerInfo();
    } else {
      // On add mode, reset phone presence and form
      setIsPhonePresent(!mode);
      // formikRef.current?.resetForm();
    }
  }, [mode]);

  useEffect(() => {
    if (id) {
      getCustomerInfo();
    }
  }, [id]);

  return (
    <div>
      <Dialog open={open} onOpenChange={setOpen}>
        <DialogTrigger asChild>
          {bookingModal ? (
            <Button
              size="sm"
              variant="ghost"
              className="group px-2 py-1 text-xs cus-sty-01"
            >
              <Icon icon="heroicons:plus-20-solid" className="h-5 w-5" />
            </Button>
          ) : (
            <Button
              size="sm"
              variant="primary"
              className="flex items-center gap-2 whitespace-nowrap"
            >
              <Icon icon="heroicons:plus-20-solid" className="h-4 w-4" />
              <span className="hidden sm:inline">Add</span>
            </Button>
          )}
        </DialogTrigger>

        <DialogContent className="custom-dialog">
          <DialogHeader>
            <DialogTitle>{id ? "Update" : "Add"} Customer</DialogTitle>
          </DialogHeader>

          <div className="text-sm text-default-500  space-y-4">
            <Formik
              innerRef={formikRef}
              onSubmit={onSubmitAddCustomer}
              initialValues={FormikInitialValues}
              validationSchema={formikValidation}
              validateOnChange={false}
              validateOnBlur={false}
            >
              {(formikProps) => (
                <>
                  <div className="md:grid md:grid-cols-1 gap-2 space-y-6 md:space-y-0">
                    <div className="col-span-1">
                      <div className="md:grid md:grid-cols-1  gap-2  space-y-6 md:space-y-0">
                        <div className="flex flex-col gap-2">
                          <FormikInput
                            formikProps={formikProps}
                            name={"firstName"}
                            label={"First Name"}
                            placeholder={"First Name"}
                            maxLength={30}
                          />
                        </div>
                        <div className="flex flex-col gap-2">
                          <FormikInput
                            formikProps={formikProps}
                            name={"lastName"}
                            label={"Last Name"}
                            placeholder={"Last Name"}
                            maxLength={30}
                          />
                        </div>
                        <div className="flex flex-col gap-2">
                          <PhoneInputField formikProps={formikProps} />
                          {existingCustomerDetails && (
                            <div className="mt-2 p-3 bg-yellow-50 border border-yellow-200 rounded-md">
                              <div className="flex items-center gap-2 mb-2">
                                <Icon
                                  icon="heroicons:exclamation-triangle"
                                  className="h-4 w-4 text-yellow-600"
                                />
                                <span className="text-sm font-medium text-yellow-800">
                                  This information already exists for another
                                  customer:
                                </span>
                              </div>
                              <div className="text-sm text-yellow-700 space-y-1">
                                <div>
                                  <strong>Name:</strong>{" "}
                                  {existingCustomerDetails.firstName}{" "}
                                  {existingCustomerDetails.lastName}
                                </div>
                                {existingCustomerDetails.email && (
                                  <div>
                                    <strong>Email:</strong>{" "}
                                    {existingCustomerDetails.email}
                                  </div>
                                )}
                                {existingCustomerDetails.phone && (
                                  <div>
                                    <strong>Phone:</strong>{" "}
                                    {existingCustomerDetails.phoneCode}{" "}
                                    {existingCustomerDetails.phone}
                                  </div>
                                )}
                              </div>
                            </div>
                          )}
                        </div>
                        {/*<div className="flex flex-col gap-2">*/}
                        {/*    <FormikInput*/}
                        {/*        formikProps={formikProps}*/}
                        {/*        name={"phone"}*/}
                        {/*        label={"Phone"}*/}
                        {/*        placeholder={"308-1234567"}*/}
                        {/*        maxLength={30}*/}
                        {/*        isPhoneNumber={true}*/}
                        {/*    />*/}
                        {/*</div>*/}

                        <div className="flex flex-col gap-2">
                          <FormikInput
                            formikProps={formikProps}
                            name={"email"}
                            label={"Email"}
                            placeholder={"customer@gmail.com"}
                            maxLength={50}
                          />
                        </div>
                        <div className="flex flex-col gap-2">
                          <FormikInput
                            formikProps={formikProps}
                            name={"cnic"}
                            label={"CNIC"}
                            placeholder={"42101-1234567-8"}
                            maxLength={15}
                          />
                        </div>
                        <div className="flex flex-col gap-2">
                          <FormikTextArea
                            formikProps={formikProps}
                            name={"address"}
                            label={"Address"}
                            placeholder={
                              "Enter customer address (min 10 characters)"
                            }
                            maxLength={1000}
                            rows={3}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                  <DialogFooter className="-2">
                    <DialogClose asChild>
                      <Button type="button" variant="outline">
                        Close
                      </Button>
                    </DialogClose>
                    <Button
                      type="button"
                      onClick={(e) => {
                        e.preventDefault();
                        formikProps.handleSubmit();
                      }}
                      disabled={formikProps.isSubmitting}
                    >
                      {formikProps.isSubmitting
                        ? "Saving..."
                        : !id
                        ? "Add"
                        : "Update"}
                    </Button>
                  </DialogFooter>
                </>
              )}
            </Formik>
          </div>
        </DialogContent>
      </Dialog>
    </div>
  );
};

export default AddCustomer;
